import { Block } from 'framework7-react';
import { FC } from 'react';
import { PopupPageTemplate } from '@/components/uiParts/Template/PopupPageTemplate/PopupPageTemplate';
import './RegisterPaymentListStyle.scss';
import { GmoCardEditParameterResponse } from '@/types/api/payment';

type RegisterPaymentListProps = {
  handleClickWithdrawFromBank: () => void;
  handleClickCreditCardPayment: () => void;
  GMOCardEditParameters: GmoCardEditParameterResponse;
  redirectPage: string;
  canWithdrawFromBank: boolean;
  actionUrl: string;
  handleClickPopupClose: () => void;
};

export const RegisterPaymentList: FC<RegisterPaymentListProps> = ({
  handleClickWithdrawFromBank,
  handleClickCreditCardPayment,
  GMOCardEditParameters,
  actionUrl,
  redirectPage,
  canWithdrawFromBank,
  handleClickPopupClose,
}) => {
  return (
    <PopupPageTemplate
      id="RegisterPaymentList"
      pageName="RegisterPayment"
      title="決済方法の追加"
      handleBack={handleClickPopupClose}
    >
      <Block className="last-block">
        <p className="u-font-bold u-font-size-xl">決済方法を選択してください</p>
        {!canWithdrawFromBank && (
          <div
            className="u-margin-top-sm info-card info-card-elevated"
            onClick={handleClickWithdrawFromBank}
          >
            <div className="pay-content">
              <div className="u-font-bold u-font-size-lg">
                <i className={`icon-bank icon`} />
              </div>
              <div className="u-padding-left-sm u-padding-right-sm">
                <p>銀行から引き落とし</p>
              </div>
              <div>
                <i className="icon-right icon" />
              </div>
            </div>
          </div>
        )}

        <div
          className="u-margin-top-sm info-card info-card-elevated"
          onClick={handleClickCreditCardPayment}
        >
          <div className="pay-content">
            <div className="u-font-bold u-font-size-lg">
              <i className={`icon-credit-card icon`} />
            </div>
            <div className="u-padding-left-sm u-padding-right-sm">
              <p>クレジットカード</p>
            </div>
            <div>
              <i className="icon-right icon" />
            </div>
          </div>
        </div>
        {/* {paymentMethods.map((method, index) => (
          <div
            className="u-margin-top-sm info-card info-card-elevated"
            key={index}
            onClick={() => handleClickCreditOrBank(method.payMethod)}
          >
            <div className="pay-content">
              <div className="u-font-bold u-font-size-lg">
                <i className={`icon-${method.icon} icon`} />
              </div>
              <div className="u-padding-left-sm u-padding-right-sm">
                <p>
                  {method.payMethod === 'bank'
                    ? '銀行から引き落とし'
                    : 'クレジットカード'}
                </p>
              </div>
              <div>
                <i className="icon-right icon" />
              </div>
            </div>
          </div>
        ))} */}
        <div className="u-margin-top-sm u-font-size-lg">
          ※外部サイトに移動します
        </div>
      </Block>
    </PopupPageTemplate>
  );
};
